import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} TabsProps
 */

/**
 * Tabs component.
 * @augments {Base<TabsProps>}
 */
export default class Tabs extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Tabs',
    refs: ['tab[]', 'content[]'],
  };

  /**
   * St current Elements
   * @returns {void}
   */
  mounted() {
    [this.currentTab] = this.$refs.tab;
    [this.currentContent] = this.$refs.content;
  }

  /**
   * Change tab
   * @param  {object} e tab clicked
   * @returns {void}
   */
  onTabClick(e) {
    this.currentTab.classList.remove('tabs__btn--active');

    this.currentTab = e.currentTarget;
    const { slug } = this.currentTab.dataset;

    this.currentTab.classList.add('tabs__btn--active');
    this.currentContent.classList.remove('tabs__content--active');
    this.currentContent = document.querySelector(`[data-id="${slug}"]`);

    this.currentContent.classList.add('tabs__content--active');
  }
}
